/* Lovy Studios — gratis-verzending-progressbar, zie snippets/lovy-free-shipping-bar.liquid */
(function () {
    var THRESHOLD_EUR = 9000; /* €90,00 in eurocenten (shopvaluta) */
    var BAR_ID = 'lovy-fsb';
    var lastTotal = -1;
    var fetching = false;
    var debounceTimer = null;

    function currencyInfo() {
      var c = (window.Shopify && window.Shopify.currency) || {};
      var rate = parseFloat(c.rate);
      return {
        code: c.active || 'EUR',
        rate: rate > 0 ? rate : 1
      };
    }

    /* Drempel omgerekend naar bezoekersvaluta, zelfde ×100-schaal als /cart.js */
    /* Vaste drempels per valuta = verzendzones (zie snippets/lovy-freeship-threshold.liquid); rest €90 × koers */
    var THRESHOLDS = { GBP: 8000, USD: 9000, CAD: 9000 };
    function threshold() {
      var c = currencyInfo();
      return THRESHOLDS[c.code] || Math.round(THRESHOLD_EUR * c.rate);
    }

    function money(cents) {
      var code = currencyInfo().code;
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en', {
          style: 'currency',
          currency: code
        }).format(cents / 100);
      } catch (e) {
        return '€' + (cents / 100).toFixed(2).replace('.', ',');
      }
    }

    function ensureBar() {
      var portal = document.getElementById('essential-cart-drawer-portal');
      if (!portal) return null;
      var header = portal.querySelector('[data-essential-cart-element="cart-drawer-header"]');
      if (!header || !header.parentNode) return null;
      /* Essential's reserveringstimer (announcement-bar) staat in het content-gedeelte;
         de balk hoort daaronder. Geen timer aanwezig → direct onder de header. */
      var content = portal.querySelector('[data-essential-cart-element="cart-drawer-content"]');
      var timer = content && content.querySelector('[data-essential-cart-element="announcement-wrapper"]');
      var bar = document.getElementById(BAR_ID);
      if (!bar || !portal.contains(bar)) {
        bar = document.createElement('div');
        bar.id = BAR_ID;
        bar.className = 'lovy-fsb';
        bar.setAttribute('role', 'status');
        bar.innerHTML =
          '<p class="lovy-fsb__text"></p>' +
          '<div class="lovy-fsb__track"><div class="lovy-fsb__fill"></div></div>';
        lastTotal = -1; /* opnieuw renderen na re-insert */
      }
      /* Alleen verplaatsen als hij nog niet op de juiste plek staat (voorkomt observer-loops). */
      if (timer) {
        if (bar.previousElementSibling !== timer) content.insertBefore(bar, timer.nextSibling);
      } else if (bar.parentNode !== header.parentNode || bar.previousElementSibling !== header) {
        header.parentNode.insertBefore(bar, header.nextSibling);
      }
      return bar;
    }

    function render(total, itemCount) {
      var bar = ensureBar();
      if (!bar) return;
      if (itemCount === 0) { bar.style.display = 'none'; return; }
      bar.style.display = '';
      if (total === lastTotal) return;
      lastTotal = total;
      var text = bar.querySelector('.lovy-fsb__text');
      var fill = bar.querySelector('.lovy-fsb__fill');
      var goal = threshold();
      var pct = Math.max(0, Math.min(100, Math.round((total / goal) * 100)));
      if (total >= goal) {
        bar.classList.add('lovy-fsb--done');
        text.innerHTML = '<b>You’ve unlocked Free Shipping!</b>';
      } else {
        bar.classList.remove('lovy-fsb--done');
        text.innerHTML = 'You’re <b>' + money(goal - total) + '</b> away from <b>Free Shipping</b>';
      }
      fill.style.width = pct + '%';
    }

    function refresh() {
      if (fetching) return;
      var portal = document.getElementById('essential-cart-drawer-portal');
      if (!portal || !portal.querySelector('[data-essential-cart-element="cart-drawer-header"]')) return;
      fetching = true;
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { render(cart.total_price, cart.item_count); })
        .catch(function () {})
        .then(function () { fetching = false; });
    }

    /* Lovy 5 sep 2026: alleen mutaties ín de Essential-lade (of het toevoegen van
       de lade) tellen; voorheen elke DOM-mutatie op de hele pagina → /cart.js.
       Eigen balk blijft genegeerd (voorkomt loops). */
    var PORTAL = 'essential-cart-drawer-portal';
    function raaktLade(m) {
      var t = m.target;
      if (t && t.closest) {
        if (t.closest('#' + BAR_ID)) return false;
        if (t.closest('#' + PORTAL)) return true;
      }
      var a = m.addedNodes;
      for (var i = 0; i < a.length; i++) {
        var n = a[i];
        if (n.nodeType === 1 && (n.id === PORTAL || (n.querySelector && n.querySelector('#' + PORTAL)))) return true;
      }
      return false;
    }
    function plan() { clearTimeout(debounceTimer); debounceTimer = setTimeout(refresh, 250); }
    var obs = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) { if (raaktLade(muts[i])) { plan(); return; } }
    });
    obs.observe(document.body || document.documentElement, { childList: true, subtree: true });
    /* Essential meldt zelf wanneer de lade opent of de cart wijzigt. */
    document.addEventListener('essential-cart:open', plan);
    document.addEventListener('cart:update', plan);
    if (document.readyState !== 'loading') refresh();
    else document.addEventListener('DOMContentLoaded', refresh);
  })();
